import membersRowUrl from './memberRow.html';

class MembersRowCtrl {
  constructor(Authentication, PersonaCollection, ConversationService) {
    'ngInject';

    Object.assign(this, { ConversationService });

    this.isManager = Authentication.user.isManager;
    this.hasAccessToUser = PersonaCollection.hasAccessToUser;
  }

  $onInit() {
    this.userCanStartPrivateConversation =
      this.ConversationService.userCanStartPrivateConversation();
  }

  sendDirectMessage = (userId) => this.ConversationService.openConversation(userId);
}

export default {
  controller: MembersRowCtrl,
  controllerAs: 'ctrl',
  bindings: {
    user: '<',
    inactive: '<',
    inactiveLabel: '@',
  },
  templateUrl: membersRowUrl,
};
